import { render, staticRenderFns } from "./WeeklyPerShift.vue?vue&type=template&id=1ed3459e&"
import script from "./WeeklyPerShift.vue?vue&type=script&lang=js&"
export * from "./WeeklyPerShift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports